const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * SCORM Content Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ScormRegistrations', ['$resource', 'appConfiguration', function($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/learn/v3/scorm/registrations/:subresource/:subsubresource', null, {
      find: {params: {subresource: '', subsubresource:''}, method: 'GET', isArray: true},
      stats: {params: {subresource: '', subsubresource:'stats'}, method: 'GET', isArray: false},
      count: {params: {subresource: '', subsubresource: 'count'}, method: 'GET', isArray: false},
      manualComplete: {params: {subsubresource: 'manual-complete'}, method: 'POST', isArray: false},
      setDataUrl: {params: {subresource: 'set-data'}, method: 'POST', isArray: false}
    });
  }]);